import React from "react";
import { DeviceWidth, useDeviceWidthQuery } from "../MediaQuery";
import { DesktopNavigation } from "./DesktopNavigation";
import { MobileNavigation } from "./MobileNavigation";

export const Navigation: React.FC = () => {
  const deviceWidth = useDeviceWidthQuery();

  return deviceWidth === DeviceWidth.mobile ? (
    <MobileNavigation />
  ) : (
    <DesktopNavigation />
  );
};
